var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67955 1.58203C0.565101 2.73607 0.50779 4.82897 1.50056 7.40242C2.48358 9.95062 4.46067 12.8598 7.20789 15.5128C9.95512 18.1658 12.9316 20.0401 15.5125 20.9336C18.1191 21.836 20.2087 21.7056 21.3231 20.5516C22.4376 19.3976 22.4949 17.3047 21.5021 14.7312C20.5191 12.183 18.542 9.27379 15.7948 6.62083C13.0476 3.96786 10.0711 2.09351 7.49015 1.20002C4.88362 0.297666 2.794 0.427984 1.67955 1.58203ZM2.26445 7.10773C1.29555 4.59613 1.50896 2.93733 2.26852 2.15079C3.02808 1.36424 4.67841 1.09307 7.2223 1.97373C9.66726 2.82015 12.5446 4.6204 15.226 7.2098C17.9074 9.79919 19.807 12.612 20.7382 15.0259C21.7071 17.5375 21.4937 19.1963 20.7341 19.9828C19.9746 20.7694 18.3243 21.0406 15.7804 20.1599C13.3354 19.3135 10.4581 17.5132 7.77666 14.9238C5.09526 12.3344 3.19568 9.52167 2.26445 7.10773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4608 7.0009C21.4197 4.51516 21.1527 3.01145 20.52 2.35627C19.8873 1.70109 18.3938 1.38175 15.8762 2.25335C13.4804 3.08274 10.6389 4.8562 7.98129 7.42259C5.32371 9.98898 3.45217 12.7669 2.53967 15.1322C1.58074 17.618 1.84776 19.1217 2.48046 19.7769C3.11316 20.4321 4.60664 20.7514 7.12433 19.8798C9.52011 19.0504 12.3616 17.2769 15.0192 14.7106C17.6768 12.1442 19.5483 9.36628 20.4608 7.0009ZM15.9994 15.7256C21.5415 10.3737 24.0199 3.94917 21.5351 1.37606C19.0502 -1.19705 12.5432 1.05563 7.00108 6.40755C1.459 11.7595 -1.01939 18.184 1.46543 20.7571C3.95025 23.3302 10.4573 21.0775 15.9994 15.7256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3267,
    y: 10.0664,
    width: 13.2,
    height: 13.2,
    rx: 6.6,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5701 13.2766H17.0082C18.3276 13.2766 19.0734 14.0511 19.0734 15.1028C19.0734 15.8008 18.6527 16.3649 18.0886 16.5561C18.7483 16.7187 19.2838 17.321 19.2838 18.1624C19.2838 19.262 18.4615 20.0555 17.1899 20.0555H14.5701V13.2766ZM15.8704 16.0781H16.8074C17.4098 16.0781 17.7731 15.7434 17.7731 15.2271C17.7731 14.7108 17.4384 14.3857 16.7978 14.3857H15.8704V16.0781ZM15.8704 18.956H16.9413C17.5819 18.956 17.9643 18.6214 17.9643 18.0764C17.9643 17.5409 17.6201 17.168 16.9604 17.168H15.8704V18.956Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.f4b9637bab88ae48ef19d5f8665a0166.svg";
export { ForwardRef as ReactComponent };